<template>
  <div class="game">
    <VText center>{{ currentQuestion }}</VText>

    <VBlock max-width="300px" :key="currentLevelIndex">
      <transition :name="getButtonTransitionName(index)"
        v-for="(answer, index) in currentAnswers" :key="index"
        appear
      >
        <VButton @click="selectAnswer(answer)">{{ answer.content }}</VButton>
      </transition>

    </VBlock>
  </div>
</template>

<script>
import shuffle from 'lodash/shuffle';
import config from './config';

const { shuffleLevels, shuffleAnswers, levels } = config;

export default {
  name: 'VGame',

  data: () => ({
    score: 0,
    currentLevelIndex: 0,
    levels: shuffleLevels
      ? shuffle(levels)
      : levels,
  }),

  computed: {
    totalLevels() {
      return this.levels.length;
    },

    currentLevel() {
      return this.levels[this.currentLevelIndex];
    },

    currentQuestion() {
      return this.currentLevel.question;
    },

    currentAnswers() {
      return shuffleAnswers
        ? shuffle(this.currentLevel.answers)
        : this.currentLevel.answers;
    },
  },

  methods: {
    getButtonTransitionName(index) {
      return index % 2 === 0
        ? 'bounceLeft'
        : 'bounceRight';
    },

    selectAnswer({ value }) {
      const nextLevelIndex = this.currentLevelIndex + 1;
      const shouldEnd = nextLevelIndex >= this.totalLevels;

      this.score = this.score + value;

      if (shouldEnd) {
        this.end();

        return;
      }

      this.currentLevelIndex = nextLevelIndex;
    },

    end() {
      this.$emit('end', {
        score: this.score,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game {}
</style>
